module.exports = __webpack_public_path__ + "static/media/PWA_Angaare.8ba74d69.jpg";